import * as React from 'react';
import { Button, Container, Row, Col } from "react-bootstrap";
import l10n, { LanguageCode } from 'localization/LocalizationData';
import QuestionnaireService from "services/QuestionnaireService";
import { RouteComponentProps, Redirect } from "react-router";
import QuestionnaireContext from "contexts/QuestionnaireContext";
import { Questionnaire } from "models/Questionnaire";
import { LinkContainer } from "react-router-bootstrap";
import { MainLayout } from "components/layouts/MainLayout";
import LoadingView from "components/views/LoadingView";
import { CheckQueryParamSettings, GetQueryCulture } from 'Utilities/QueryParamSettings';

export interface StartProps {
	id: string;
}

export const QuestionnaireStartPage = (props: RouteComponentProps<StartProps>) => {
	const context = React.useContext(QuestionnaireContext);
	const [loading, setLoading] = React.useState(true);
	const [questionnaire, setQuestionnaire] = React.useState<Questionnaire>();
	const [token, setToken] = React.useState<string | undefined>();
	const [retry, setRetry] = React.useState(false);

	CheckQueryParamSettings(props.location.search);

	if (CheckQueryParamSettings(props.location.search)) {
		const queryCulture = GetQueryCulture();
		if (queryCulture) {
			l10n.setLanguage(queryCulture);
		}
	}


	React.useEffect(() => {
		if (props.match.params.id !== undefined) {

			setLoading(true);
			const request = async () => {
				try {
					const result = await QuestionnaireService.get(props.match.params.id, l10n.getLanguage() as LanguageCode);
					setQuestionnaire(result);
				}
				catch (reason) {
					console.log(reason);
				}
				setLoading(false);
			};
			request();
		}

	}, [props.match.params.id]);

	React.useEffect(() => {
		if (retry) {
			setLoading(true);
			const request = async () => {
				try {
					const result = await QuestionnaireService.get(props.match.params.id, l10n.getLanguage() as LanguageCode);
					setQuestionnaire(result);
				}
				catch (reason) {
					console.log(reason);
				}
				setRetry(false);
				setLoading(false);
			};
			request();
		}

	}, [retry, props.match.params.id])

	React.useEffect(() => {
		if (questionnaire && token && context.inprogress === false) {
			context.startQuestionnaire(questionnaire, token);
		}
	});

	if (questionnaire && token) {
		return <Redirect to={`/questionnaire/${questionnaire.id}/question/0?hint`} />
	}

	if (loading) {

		return <MainLayout>
			<LoadingView  title={l10n.loading} />
		</MainLayout>
	}

	async function onStart() {
		setLoading(true);
		try {
			const token = await QuestionnaireService.start(props.match.params.id, l10n.getLanguage() as LanguageCode);
			setLoading(false);
			setToken(token.token);
		}
		catch (reason) {
			setLoading(false);
		}
	}
	
	if (questionnaire !== undefined) {
		return (
			<MainLayout>
				<Container className='mt-4'>
					<h1 className='mb-4 text-center'>{questionnaire.name}</h1>
					
					{
						questionnaire.description &&
						<Row className='justify-content-center text-center'>
							<Col xs='auto' sm='8' className='mb-2'><p>{questionnaire.description}</p></Col>
						</Row>
					}
					<Row className='justify-content-center'>
						<Col xs='auto' className='mb-2'><p>{l10n.start_description}</p></Col>
					</Row>
					<Row className='justify-content-center'>
						<Col xs='3' className='d-flex justify-content-center'>
							<LinkContainer to={{
								pathname: '/questionnaire',
								state: { from: 'start' }
							}}>
								<Button className='mr-3'>{l10n.button_cancel}</Button>
							</LinkContainer>
						</Col>
						<Col xs='3' className='d-flex justify-content-center'>
							<Button onClick={() => onStart()}>{l10n.button_start}</Button>
						</Col>
					</Row>

				</Container >
			</MainLayout>
		);

	}
	return <MainLayout header={
		<LinkContainer to='/'>
			<Button>{l10n.button_toHome}</Button>
		</LinkContainer>
	}>
		<Container>
			<Row className='justify-content-center mb-4 mt-4'><h2>{l10n.error_generic}</h2></Row>
			<Row className='justify-content-center'><Col xs='auto'><Button onClick={() => setRetry(true)}>{l10n.button_tryAgain}</Button></Col></Row>
		</Container>
	</MainLayout>
}